import { __assign } from '../node_modules/tslib/tslib.es6.mjs.js';
import React from 'react';
import { Icon } from '@chakra-ui/react';

var CheckoutClick = function (props) { return (React.createElement(Icon, __assign({ width: "20px", height: "20px", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M16.25 4.375H2.5C2.15482 4.375 1.875 4.65482 1.875 5V12.5C1.875 12.8452 2.15482 13.125 2.5 13.125H16.25C16.5952 13.125 16.875 12.8452 16.875 12.5V5C16.875 4.65482 16.5952 4.375 16.25 4.375Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M10.75 8.25L10.75 17.25L13.15 14.95L15.45 19.25L17.05 18.4L14.75 14.1L17.5 14.1L10.75 8.25Z", fill: "currentColor" }))); };

export { CheckoutClick as default };
//# sourceMappingURL=CheckoutClick.js.map
